import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { APP_URL } from "../request/api";
import { request } from "../request/request";

const initialState = {
    columns: [],
    data: [],
    meta: {},
    links: {},
    loadingStatus: "idle",
    error: null
}

export const fetchVehicles = createAsyncThunk(
    "vehicles/fetchVehicles",
    async ({token, page, params}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            return await request(
                `${APP_URL}/vehicles?${page}&${params}`,
                'GET',
                null,
                customHeaders
            )
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

const vehiclesSlice = createSlice({
    name: "vehicles",
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchVehicles.pending, (state) => {
                state.loadingStatus = "loading";
                state.columns = null;
                state.data = null;
                state.meta = null;
                state.links = null;
            })
            .addCase(fetchVehicles.fulfilled, (state, action) => {
                state.loadingStatus = "idle";
                state.columns = action.payload.columns;
                state.data = action.payload.data;
                state.meta = action.payload.meta;
                state.links = action.payload.links;
            })
            .addCase(fetchVehicles.rejected, (state, action) => {
                state.loadingStatus = "error";
                state.columns = null;
                state.data = null;
                state.meta = null;
                state.links = null;
                state.error = action.payload;
            })
    }
})

export default vehiclesSlice.reducer;